var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCalendarDate2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    fill: "none",
    stroke: "currentColor",
    className: "calendar-date-2_svg__nc-icon-wrapper",
    transform: "translate(.5 .5)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 6,
    width: 42,
    height: 39,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 11V2M35 11V2M3 17h42M9 31h30M18 23v16M30 23v16"
  }))));
}

export default SvgCalendarDate2;